import { useMutation, useQuery, useQueryClient } from 'react-query';
import qs from 'qs-lite';

import api from '../../utils/api';
import config from '../../config';
import { PLUGINS } from '../../constants/endpoints';
import { useVpSnackbar } from '../../vp-ui';

const getPluginId = (id) => {
  const pathname = window?.location?.pathname || '';
  const pathSplit = pathname.split('plugins/');
  const pluginPageId = pathSplit.length > 1 ? pathSplit.pop() : null;
  return id || pluginPageId;
};

// start queries
const fetchPlugins = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);

  return api.get(`${PLUGINS}${queryString ? `?${queryString}` : ''}`);
};
export const useFetchPlugins = () => {
  const { limit = '25', offset = '0' } = qs.parse(window?.location?.search?.split('?')?.[1]) || {};
  const queryProps = {
    limit,
    offset,
    orderBy: 'createdAt',
    sortOrder: 'DESC'
  };

  return useQuery([PLUGINS, { ...queryProps }], fetchPlugins, {
    keepPreviousData: true
  });
};

const fetchPluginById = ({ queryKey }) => {
  const pluginId = queryKey[1];
  const preview = queryKey[2];
  return api.get(`${PLUGINS}/${pluginId}${preview ? '/preview' : ''}`);
};
export const useFetchPluginById = (props = {}) => {
  const { pluginId, preview = true } = props;
  const pluginIdToUse = getPluginId(pluginId);

  return useQuery([PLUGINS, pluginIdToUse, preview], fetchPluginById, {
    enabled: !!pluginIdToUse
  });
};
// end queries

// start mutations
const createPlugin = (data) => api.post(`${config.endpoints.createPlugin}`, data);
export const useCreatePlugin = () => useMutation(createPlugin);

const updatePluginPreview = ({ pluginId, data }) => api.put(`${PLUGINS}/${pluginId}/preview`, data);
export const useUpdatePluginPreview = () => {
  const queryClient = useQueryClient();

  return useMutation(updatePluginPreview, {
    onSuccess: (res) => {
      queryClient.invalidateQueries([PLUGINS, res?.id]);
    }
  });
};

const updatePlugin = ({ pluginId, data }) => api.put(`${PLUGINS}/${pluginId}`, data);
export const useUpdatePlugin = () => {
  const { addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();
  const pluginPageId = getPluginId();

  return useMutation(updatePlugin, {
    onSuccess: () => {
      addSnackbarSuccess({
        message: 'Successfully published plugin'
      });
      queryClient.invalidateQueries([PLUGINS, pluginPageId]);
    }
  });
};

const rollbackPlugin = (pluginId) => api.put(`${PLUGINS}/${pluginId}/preview/rollback`);
export const useRollbackPlugin = () => {
  const queryClient = useQueryClient();
  const pluginPageId = getPluginId();

  return useMutation(() => rollbackPlugin(pluginPageId), {
    onSuccess: () => {
      queryClient.invalidateQueries([PLUGINS, pluginPageId]);
    }
  });
};

const deletePlugin = (pluginId) => api.delete(`${PLUGINS}/${pluginId}`);
export const useDeletePlugin = () => {
  const queryClient = useQueryClient();
  const { addSnackbarSuccess } = useVpSnackbar();

  return useMutation((pluginId) => deletePlugin(pluginId), {
    onSuccess: () => {
      queryClient.invalidateQueries([PLUGINS]);
      addSnackbarSuccess({ message: 'Successfully deleted plugin' });
    }
  });
};
// end mutations



// WEBPACK FOOTER //
// ./src/hooks/react-query/usePluginData.js